import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=4652239a&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"
import style0 from "./Color.vue?vue&type=style&index=0&id=4652239a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652239a",
  null
  
)

export default component.exports